import createPersistedState from 'use-persisted-state';

function storageMock() {
    let storage = {};

    return {
        setItem: function(key, value) {
            storage[key] = value || '';
        },
        getItem: function(key) {
            return key in storage ? storage[key] : null;
        },
        removeItem: function(key) {
            delete storage[key];
        },
        get length() {
            return Object.keys(storage).length;
        },
        key: function(i) {
            const keys = Object.keys(storage);
            return keys[i] || null;
        }
    };
}

const useExpandedMenu = () => {

    let storage;
    try {
        storage = localStorage;
    } catch (e) {
        storage = storageMock();
    }

    const useExpandedMenuSections = createPersistedState('expandedMenu', storage);
    const [expandedMenuSections, setExpandedMenuSections] = useExpandedMenuSections({indexes: [1], enabled: false, isDirty: false, scroll: 0});

    return [expandedMenuSections, setExpandedMenuSections];
}

export default useExpandedMenu;